import { render, staticRenderFns } from "./publishingTrends.vue?vue&type=template&id=5c546744&scoped=true"
import script from "./publishingTrends.vue?vue&type=script&lang=js"
export * from "./publishingTrends.vue?vue&type=script&lang=js"
import style0 from "./publishingTrends.vue?vue&type=style&index=0&id=5c546744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c546744",
  null
  
)

export default component.exports